import { render } from "./TextbookMappingModal.vue?vue&type=template&id=347f77d0&scoped=true"
import script from "./TextbookMappingModal.vue?vue&type=script&lang=js"
export * from "./TextbookMappingModal.vue?vue&type=script&lang=js"

import "./TextbookMappingModal.vue?vue&type=style&index=0&id=347f77d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347f77d0"]])

export default __exports__